// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function fromString(orderType) {
  var match = orderType.toLowerCase();
  switch (match) {
    case "businesscustomer" :
        return /* BusinessCustomer */6;
    case "courier" :
        return /* Courier */3;
    case "loadassist" :
        return /* LoadAssist */4;
    case "ondemand" :
        return /* OnDemand */0;
    case "partload" :
        return /* PartLoad */7;
    case "pnm" :
        return /* PNM */2;
    case "rental" :
        return /* Rental */1;
    case "vehiclepluslabour" :
        return /* VehiclePlusLabour */5;
    default:
      return ErrorUtils$Catalyst.raiseError("OrderType.res", "Invalid order type", orderType);
  }
}

function toString(orderType) {
  switch (orderType) {
    case /* OnDemand */0 :
        return "ondemand";
    case /* Rental */1 :
        return "rental";
    case /* PNM */2 :
        return "pnm";
    case /* Courier */3 :
        return "courier";
    case /* LoadAssist */4 :
        return "loadassist";
    case /* VehiclePlusLabour */5 :
        return "vehiclepluslabour";
    case /* BusinessCustomer */6 :
        return "businesscustomer";
    case /* PartLoad */7 :
        return "partload";
    
  }
}

export {
  fromString ,
  toString ,
}
/* No side effect */
